(function () {
  'use strict';

  angular
      .module('tfc.retailer.StandardReports')
      .controller('LegendGroupCtrl', LegendGroupCtrl);

  // @ngInject
  function LegendGroupCtrl() {
    var vm = this;
  }
  })();
